<template>
  <header>
    <nav class="navbar navbar-expand-lg navbar-light main-color">
      <a class="mr-4 text-light h2" href="#">{{this.config.projectName}}</a>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav mr-auto">
          <!--<li class="nav-item active">
            <a class="nav-link text-light" href="#">制作案件一覧 <span class="sr-only">(current)</span></a>
          </li> -->
        </ul>
        <span class="navbar-text">
          <button class="btn btn-outline-light" @click.stop.prevent="logout()">ログアウト</button>
        </span>
      </div>
    </nav>
  </header>
</template>
<script>
export default {
  name: 'TraderHeader',
  methods: {
    logout () {
      this.$router.push('/trader/login')
    }
  },
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TraderHeader.vue